// Utils
import { isNullUndefined } from "@/main/services/utils";

interface StarRatingPartiallyProps {
	rating: number;
}
const StarRatingPartially = ({ rating }: StarRatingPartiallyProps) => {
	const ratingIsInvalid = rating < 0 || isNullUndefined(rating);
	const quantityStars = 5;

	const ratingInPercentage = () => {
		if (!ratingIsInvalid) {
			if (rating > 0 || rating <= 5) return (rating / quantityStars) * 100;
		}
		return 0;
	};

	return (
		<div className="star-ratingpartially__container">
			<div className="star-ratingpartially__empty"></div>

			{!ratingIsInvalid && (
				<div className="star-ratingpartially__full" style={{ width: `${ratingInPercentage()}%` }}></div>
			)}
		</div>
	);
};

export default StarRatingPartially;
